import { useAcessoLotacaoOrEstagio } from 'components/auth/useAcessoLotacao'
import { useServerTime } from 'hooks/useServerTime'
import { useLocalStorageState } from 'hooks/useStorage'
import { useCallback } from 'react'

import { TerritorioMapaBuscaFormModel } from '../mapa-busca/model-territorioMapaBusca'
import { TerritorioMapaCacheModel } from '../model-territorioMapa'
import { resetCacheIfExpired } from '../utils-mapaCache'

export function useTerritorioMapaCache(defaultFilter: TerritorioMapaBuscaFormModel) {
  const { acesso } = useAcessoLotacaoOrEstagio()
  const { getServerTimeNow } = useServerTime()

  const [cache, setCache] = useLocalStorageState<TerritorioMapaCacheModel>(`${acesso.id}/mapa-territorio`, {
    defaultValue: () => ({
      filter: defaultFilter,
      lastUpdated: getServerTimeNow().getTime(),
    }),
    modifier: (cacheValue) => resetCacheIfExpired(cacheValue, defaultFilter, getServerTimeNow().getTime()),
    checkVersionCompatibility: true,
  })

  const updateFilter = useCallback(
    (appliedFilters: TerritorioMapaBuscaFormModel) => {
      const updatedAt = getServerTimeNow().getTime()

      setCache({
        filter: appliedFilters,
        lastUpdated: updatedAt,
      })
    },
    [getServerTimeNow, setCache]
  )

  return {
    filter: cache.filter,
    updateFilter,
  }
}
